import React, { useEffect, useState, useMemo } from 'react';
import { Table } from 'semantic-ui-react';
import NumberFormat from 'react-number-format';
import { getSalesOrderFormData } from '../../../action/salesOrder';
import { setRate } from './setRate';
import { roundCurrency } from '../../../util/currency';

const SalesOrderProductListItem = ({
  SOIID,
  Currency,
  Quantity,
  Discount,
  Amount,
  ProductCode,
  Model,
  Color,
  Voltage,
  HDD,
  SSD,
  Item,
  AACost,
  USDRetail,
  KRWRetail,
  Description,
  HS_CODE,
  serials,
  customDescription,
  onCustomDescription,
  sku,
  onRateChange,
  company,
  billingCountry,
}) => {
  const rate = useMemo(() => {
    const calculatedRate = setRate(
      {
        AACost: AACost,
        USDRetail: USDRetail,
        KRWRetail: KRWRetail,
      },
      Currency,
      company,
      billingCountry
    );

    return calculatedRate;
  }, [
    AACost,
    USDRetail,
    KRWRetail,
    Currency,
    company,
    billingCountry,
    ProductCode,
    SOIID,
  ]);

  const [localRate, setLocalRate] = useState(rate);

  useEffect(() => {
    setLocalRate(rate);
  }, [rate]);

  // Calculate FOB Price with proper rounding to avoid floating point precision errors
  const rawFobPrice = localRate * ((100 - (Discount || 0)) / 100);
  const fobPrice = roundCurrency(rawFobPrice, Currency);

  // Calculate Amount with proper rounding
  const calculatedAmount = roundCurrency(fobPrice * Quantity, Currency);

  return (
    <Table.Row>
      <Table.Cell id="ListItems" className="ListItem">
        <p style={{ fontWeight: 900 }}>{ProductCode.trim()}</p>

        {Model.trim() == 'CS_Parts' ? (
          <p style={{ margin: 0, fontSize: '12px' }}>
            SKU:{' '}
            {sku ? sku : `${Model.trim()}-${Item != null ? Item.trim() : ''}`}
          </p>
        ) : (
          <p style={{ margin: 0, fontSize: '12px' }}>
            SKU:{' '}
            {sku
              ? sku
              : `${Model.trim()}-${Color.trim()}-${Voltage.trim()}-${HDD.trim()}-${SSD.trim()}`}
          </p>
        )}
        <p style={{ margin: 0, fontSize: '12px' }}>
          {Description == undefined ? '' : Description.trim()}
          {Description == undefined || HS_CODE == undefined ? '' : ' / '}
          {HS_CODE == undefined ? '' : HS_CODE.trim()}
        </p>
        <p style={{ margin: 0, fontSize: '12px' }}>
          {serials == undefined
            ? ''
            : serials.map((serial) => serial.Serial).join(', ')}
        </p>
        <input
          value={customDescription}
          onChange={onCustomDescription}
          style={{
            width: 200,
          }}
        />
      </Table.Cell>
      <Table.Cell
        id="ListItems"
        className="ListItem"
        style={{ textAlign: 'right' }}
      >
        <NumberFormat
          value={Quantity}
          displayType={'text'}
          thousandSeparator={true}
        />
      </Table.Cell>
      <Table.Cell
        id="ListItems"
        className="ListItem"
        style={{ textAlign: 'right' }}
      >
        <NumberFormat
          value={localRate}
          displayType={'input'}
          thousandSeparator={true}
          prefix={Currency == 'KRW' ? '₩' : '$'}
          onValueChange={(values) => {
            const newRate = isNaN(values.floatValue) ? 0 : values.floatValue;
            setLocalRate(newRate);
            if (onRateChange) onRateChange(SOIID, newRate, Currency);
          }}
        />
      </Table.Cell>
      <Table.Cell
        id="ListItems"
        className="ListItem"
        style={{ textAlign: 'right' }}
      >
        <NumberFormat
          value={Discount}
          displayType={'text'}
          thousandSeparator={true}
        />
      </Table.Cell>
      <Table.Cell
        id="ListItems"
        className="ListItem"
        style={{ textAlign: 'right', paddingRight: '14px' }}
      >
        <NumberFormat
          value={fobPrice}
          displayType={'text'}
          thousandSeparator={true}
          prefix={Currency == 'KRW' ? '₩' : '$'}
        />
      </Table.Cell>
      <Table.Cell
        id="ListItems"
        className="ListItem"
        style={{ textAlign: 'right', paddingRight: '14px' }}
      >
        <NumberFormat
          value={calculatedAmount}
          displayType={'text'}
          thousandSeparator={true}
          prefix={Currency == 'KRW' ? '₩' : '$'}
        />
      </Table.Cell>
    </Table.Row>
  );
};

export default SalesOrderProductListItem;
